<template>
  <svg viewBox="0 0 64 64">
    <path
      style="fill: #393a3a"
      d="M23,15.5h3v2.7h-3V15.5z M26,13.9h-3v-1h3V13.9z M21.5,19.8h6v-8.4h-6V19.8z"
    />
    <path
      style="fill: #393a3a"
      d="M31.1,12.9v5.3l3,0v-5.3L31.1,12.9z M29.7,19.8v-8.4l6,0v8.4L29.7,19.8z"
    />
    <path
      style="fill: #393a3a"
      d="M39.3,18.2h3v-5.3h-3V18.2z M43.8,19.8h-6v-8.4h6V19.8z"
    />
    <path
      style="fill: #393a3a"
      d="M23,31.2h3v-5.3h-3V31.2z M27.5,32.8h-6v-8.4h6V32.8z"
    />
    <path
      style="fill: #393a3a"
      d="M31.1,31.2h3v-5.3l-3,0V31.2z M35.6,32.8h-6v-8.4l6,0V32.8z"
    />
    <path
      style="fill: #393a3a"
      d="M39.3,29.4h3v1.9h-3V29.4z M42.3,27.8h-3v-1.9h3V27.8z M37.8,32.8h6v-8.4h-6V32.8z"
    />
    <path
      style="fill: #393a3a"
      d="M23,41.7h3v2.5h-3V41.7z M26,40.2h-3V39h3V40.2z M21.5,45.8h6v-8.4h-6V45.8z"
    />
    <path
      style="fill: #393a3a"
      d="M31.1,41.7h3v2.5h-3V41.7z M34.1,40.2h-3V39h3V40.2z M29.7,45.8h6v-8.4h-6V45.8z"
    />
    <path
      style="fill: #393a3a"
      d="M39.3,44.3h3V39h-3V44.3z M43.8,45.8h-6v-8.4h6V45.8z"
    />
    <g>
      <defs>
        <rect id="SVGID_1_" x="12.9" y="2" width="39.5" height="59.5" />
      </defs>
      <clipPath id="SVGID_2_">
        <use href="#SVGID_1_" style="overflow: visible" />
      </clipPath>
      <path
        style="clip-path: url(#SVGID_2_); fill: #393a3a"
        d="M34.1,60h-1.3l-1.7,0v-7.7h3V60z M43.3,51.9c0-2,1.3-3.6,3.1-4c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1
		c1.7,0.4,3.1,2,3.1,4c0,2-1.3,3.6-3.1,4C47.6,56,47.4,56,47.1,56c-0.3,0-0.5,0-0.7-0.1C44.6,55.5,43.3,53.9,43.3,51.9 M47.8,57.5
		c2.6-0.4,4.5-2.7,4.5-5.5c0-2.8-2-5.2-4.5-5.5V3.8l2-0.2L49.7,2L15.4,5.5L15.6,7l1.9-0.2v47.5c-2.6,0.4-4.5,2.7-4.5,5.5h1.5
		c0-2,1.3-3.6,3.1-4c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1c1.7,0.4,3.1,2,3.1,4h1.5c0-2.8-2-5.2-4.5-5.5V6.7l27.5-2.8v42.5
		c-2.6,0.4-4.5,2.7-4.5,5.5c0,2.8,2,5.2,4.5,5.5V60H35.6v-9.2h-6V60H12.9v1.6l16.8,0h3.2l18.8,0V60h-3.8V57.5z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconAppartement extends Vue {}
</script>
